export const START_TRACK = 'ONBOARDING/START_TRACK'
export const COMPLETE_TRACK = 'ONBOARDING/COMPLETE_TRACK'
export const COMPLETE_BRANCH = 'ONBOARDING/COMPLETE_BRANCH'
export const FINALIZE_TRACK = 'ONBOARDING/FINALIZE_TRACK'
export const NEXT_STEP = 'ONBOARDING/NEXT_STEP'
export const NAVIGATE_TO_URL = 'ONBOARDING/NAVIGATE_TO_URL'

export const SET_DATA = 'ONBOARDING/SET_DATA'
export const DISMISS_CARD = 'ONBOARDING/DISMISS_CARD'
export const INTERRUPT_TRACK = 'ONBOARDING/INTERRUPT_TRACK'
export const SHOW_ONBOARDING_MODAL = 'ONBOARDING/SHOW_MODAL'
export const CONFIRM_INTERRUPT = 'ONBOARDING/CONFIRM_INTERRUPT'
export const AUTORUN_START_TRACK = 'ONBOARDING/AUTORUN_START_TRACK'

// TODO(backend): enable when onboarding progress API is ready
// export const LOAD_PROGRESS = 'ONBOARDING/LOAD_PROGRESS'
// export const SAVE_PROGRESS = 'ONBOARDING/SAVE_PROGRESS'
